"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
const steps = [{
  title: "Quick Installation",
  description: "We deliver and set up the ZapGO! charging station at your venue completely free of charge. No complex wiring required."
}, {
  title: "Plug & Play",
  description: "Simply plug the station into a standard power outlet. Its compact, modern design fits seamlessly into any environment."
}, {
  title: "Earn Passive Income",
  description: "Attract more foot traffic and earn a commission on every powerbank rented from your location. We handle all maintenance."
}];
export default function Solution() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="solution" className="bg-background relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="bg-primary/10 absolute top-1/2 left-0 -translate-y-1/2 -translate-x-1/2 h-[500px] w-[500px] rounded-full blur-[120px] pointer-events-none" />
      
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={sectionRef} className={`grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center transition-all duration-1000 ${isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          
          {}
          <div ref={imageRef} className={`relative group transition-all duration-1000 delay-200 ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="absolute -inset-4 bg-gradient-to-tr from-primary/20 to-accent/20 rounded-[2.5rem] blur-2xl opacity-50 group-hover:opacity-70 transition-opacity duration-500" />
            <div className="bg-card/40 border-border/50 relative rounded-[2rem] border p-4 backdrop-blur-xl shadow-2xl">
              <div className="bg-muted/50 relative overflow-hidden rounded-2xl aspect-[4/5]">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586523/img/zapgo_station_hardware_showcase.png" alt="ZapGO! Charging Station Hardware" className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-12">
            <div>
              <h2 className="text-foreground text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4">
                Effortless Integration, <span className="text-primary">Instant Value</span>
              </h2>
              <p className="text-muted-foreground text-lg max-w-xl">
                Transform a small footprint into a valuable service for your customers and a new revenue stream for your business.
              </p>
            </div>

            <div className="space-y-10">
              {steps.map((step, i) => <div key={i} data-index={i} className="flex gap-6 md:gap-8 items-start group">
                  <div className="shrink-0 relative">
                    <span className="text-6xl md:text-7xl font-black text-transparent [-webkit-text-stroke:2px_var(--color-primary)] opacity-50 group-hover:opacity-100 group-hover:[-webkit-text-stroke:2px_var(--color-accent-foreground)] transition-all duration-300 select-none">
                      0{i + 1}
                    </span>
                  </div>
                  <div className="pt-2 md:pt-4">
                    <h3 className="text-foreground text-xl md:text-2xl font-semibold mb-2 group-hover:text-primary transition-colors duration-300">
                      {step.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="pt-4">
              <Button size="lg" className="rounded-full px-8 h-14 text-base group" asChild>
                <Link to="/SupportPage">
                  Get Started
                  <ArrowRight className="ml-2 size-5 group-hover:translate-x-1 transition-transform" />
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}